import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { palette, radius } from './designTokens';

const EmptyState = ({ icon, title, description, action, variant = 'default', iconBg, iconColor }) => {
  return (
    <Box
      sx={{
        // `bare` is for an empty state that already sits inside a card: the
        // dashed frame is what tells a bare page "something belongs here", and
        // inside a bordered panel it is just a second box around the first.
        py: variant === 'bare' ? 4 : 6,
        px: 3,
        textAlign: 'center',
        borderRadius: `${radius.md}px`,
        border: variant === 'bare' ? 'none' : `2px dashed ${palette.line}`,
        bgcolor: variant === 'bare' ? 'transparent' : palette.surfaceAlt,
      }}
    >
      <Stack alignItems="center" spacing={1.25}>
        {icon && (
          <Box
            sx={{
              width: 64, height: 64,
              borderRadius: '50%',
              bgcolor: iconBg ?? palette.brandSoft,
              color: iconColor ?? palette.brand,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        )}
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: palette.ink }}>
          {title}
        </Typography>
        {description && (
          <Typography sx={{ fontSize: 13, color: palette.muted, maxWidth: 420 }}>
            {description}
          </Typography>
        )}
        {action && <Box sx={{ mt: 1 }}>{action}</Box>}
      </Stack>
    </Box>
  );
};

export default EmptyState;
